<template>
  <div
    class="product-service-text"
    :class="{ 'product-service-text_disabled': disabled }"
    @click="$emit('click', $event)"
  >
    <slot />
    <!--    <svg class="product-service-text__icon"><use xlink:href="#svg-plus"></use></svg>-->
  </div>
</template>

<script>
export default {
  name: 'ProductServiceText',
  props: {
    result: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.product-service-text {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  //align-items: center;
  //justify-content: space-between;
  //font-weight: 500;
  //font-size: rem(14);
  //line-height: 125%;
  //width: 100%;
  //cursor: pointer;
  //padding: 11px 0;
  //&__icon {
  //  width: 16px;
  //  height: 16px;
  //  fill: var(--background-black);
  //}
  :deep(svg) {
    width: 18px;
    height: 18px;
    margin-right: 6px;
    fill: currentColor;
  }
  &_disabled {
    pointer-events: none;
    opacity: 0.4;
    cursor: not-allowed;
  }
}
</style>
